/* globals Fancybox */
import { Fancybox } from '@fancyapps/ui';
import '@fancyapps/ui/dist/fancybox/fancybox.css';

// Youtube/Vimeo popups
Fancybox.bind('.popup-youtube, .popup-vimeo', {
	on: {
		done: (fancybox) => {
			const containerSection = fancybox.options.triggerEl.closest('section');
			if (containerSection) {
				const transcription = containerSection.querySelector('[data-video-transcription]');
				if (transcription) {
					const boxContent = fancybox.container.querySelector('.fancybox__content');

					if (!boxContent.querySelector('[data-video-transcription]')) {
						const transcriptionClone = transcription.cloneNode(true);
						transcriptionClone.classList.remove('hidden');
						transcriptionClone.classList.add('absolute', 'w-full', 'top-full', 'left-0');
						boxContent.classList.add('relative');
						boxContent.classList.add('overflow-hidden');
						boxContent.classList.add('!rounded-t-2xl');
						boxContent.append(transcriptionClone);
					}
				}
			}

			const closeBtn = fancybox.container.querySelector('.is-close-btn');
			closeBtn.classList.add(
				'!size-12',
				'!flex',
				'!items-center',
				'!justify-center',
				'!bg-secondary',
				'!rounded-sm',
				'!opacity-100',
				'!top-0',
				'!right-10',
				'lg:!right-0',
				'!translate-x-1/2',
				'!-translate-y-1/2',
				'hocus:scale-125'
			);

			closeBtn.focus();

			const iframe = fancybox.container.querySelector('iframe');
			const iframeWrapper = document.createElement('div');
			iframeWrapper.setAttribute('class', 'h-full rounded-t-2xl overflow-clip');

			iframe.setAttribute('title', 'Play Video');
			iframeWrapper.appendChild(iframe.cloneNode());
			iframe.outerHTML = iframeWrapper.outerHTML;
		},
	},
});

// Default WP Gallery popups
Fancybox.bind('.popup-gallery', {
	Thumbs: {
		type: 'classic',
	},
	on: {
		done: (fancybox) => {
			fancybox.container.querySelector('[data-fancybox-close]').focus();
		},
	},
});
